import { isEmpty } from 'lodash'
import React from 'react'
import Privacy from 'shared/components/privacy/privacy'
import { IChannel } from 'shared/types/channel'

const ChannelPrivacy = ({ channel, isOwner }: { channel: IChannel; isOwner: boolean }) => {
    const { is_private, ancestors } = channel
    let whichPage, subTitle, editPath
    // Private Channel Message
    if (isOwner) {
        whichPage = 'Your'
        subTitle = 'To make it shareable go to your Settings & switch your channel to "Public"'
        editPath = 'settings'
    } else {
        whichPage = 'This'
        subTitle = 'To make it shareable the owner must switch it to "Public"'
    }
    return is_private || (!isEmpty(ancestors) && ancestors[0].is_private) ? (
        <Privacy title={`${whichPage} page is private.`} subTitle={subTitle} editPath={editPath} />
    ) : null
}

export default ChannelPrivacy
